import taskManagerApi from "@/features/shared/services/taskManagerApi";
const API_ROUTE = "/leave_balance";
export const fetchLeaveBalances = async (page = 1, filters = {}, limit = 10) => {
    const params = { page, limit, ...filters };
    const response = await taskManagerApi.get(API_ROUTE, { params });
    const { items, meta } = response.data?.data ?? {};
    return {
        leaveBalances: items ?? [],
        meta: meta ?? null,
    };
};
export const createLeaveBalance = async (payload) => {
    const response = await taskManagerApi.post(API_ROUTE, payload);
    return response.data?.data;
};
export const updateLeaveBalance = async (id, payload) => {
    await taskManagerApi.put(`${API_ROUTE}/${id}`, payload);
};
export const deleteLeaveBalance = async (id) => {
    await taskManagerApi.delete(`${API_ROUTE}/${id}`);
};
